//
// Module for the Tax Tables and Rates index view
//
rs.module("system/configuration/taxtablesandrates/index",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrls) {

            // Unpack js Selectors
            var criteria = $.js(jsSelectors.criteria);
            var filterRadioContainer = criteria.js(jsSelectors.filterRadioContainer);
            var filterRadioContainerSpinner = criteria.js(jsSelectors.filterRadioContainerSpinner);


            // Hook up click event on the radio buttons to reload the grid data via ajax
            filterRadioContainer.find("input").on('click', function () {

                filterRadioContainerSpinner.show();

                // Fetch Tax Table grid's new data.
                gridModule.update(
                    backendUrls.getTaxTablesAsync,
                    { currentOnly: this.value },
                    lrsGridApi.agGridApi,
                    function done() {
                        filterRadioContainerSpinner.hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);